<template lang="pug">
  .product-list
    .header-area(v-if="areas.header && areas.header.length")
      //- section(v-for="(section, index) in areas.header" :key="section.id" :class="section.key" v-if="index === 0")
      //-   Banner(v-if="section.key === 'banner'" :section="section")
      //-   Slider(v-if="section.key === 'slider'" :section="section")
    .main-area(v-if="areas.main && areas.main.length")
      template(v-for="(section, index) in areas.main" v-if="isAllowed(section.key, 'main')")
        Heading.container.mx-auto(v-if="section.key === 'heading'" :section="section")
        Post.container.mx-auto(v-if="section.key === 'post'" :section="section")
        CategoryProducts.container.mx-auto(v-if="section.key === 'categoryproducts'" :section="section" default-orientation="horizontal")
        ProductList.container.mx-auto(v-if="section.key === 'products'" :section="section" default-orientation="horizontal")
</template>

<script>
import Page from '@/views/Page';

import Heading from '@/sections/Heading';
import Post from '@/sections/Post';

import CategoryProducts from '@/extensions/shop/sections/CategoryProducts';
import ProductList from '@/extensions/shop/sections/ProductList';

export default {
  name: 'Products',
  extends: Page,
  components: {
    Heading,
    Post,
    CategoryProducts,
    ProductList
  },
  methods: {
    isAllowed(key, area = 'main') {
      switch (area) {
        // case 'header':
        //   return ['banner', 'slider'].includes(key);

        case 'main':
        default:
          return ['categoryproducts', 'products', 'post', 'heading'].includes(key);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
section.slider,
section.banners
  padding: 0
.product-list
  display: flex
  flex-direction: column
  .main-area, section
    display: flex
    flex-direction: column
    flex-grow: 1
  section.heading
    padding-bottom: 0
    flex-grow: 0
  section.post
    flex-grow: 0
</style>
